import { CompleteProfilePrompt } from "./CompleteProfilePrompt";

export default CompleteProfilePrompt;
